export default "__VITE_ASSET__8fe4ad72__"